import {
  useEffect,
  useState
} from "react";

import MainLayout from "../../components/layout/MainLayout";

import {
  getMaterials,
  createMaterial,
  updateMaterial,
  deleteMaterial
} from "../../api/materialApi";

import {
  FaPlus,
  FaEdit,
  FaTrash
} from "react-icons/fa";

const Materials = () => {

  const [materials, setMaterials] =
    useState([]);

  const [showModal, setShowModal] =
    useState(false);

  const [editingId, setEditingId] =
    useState(null);

  const [form, setForm] =
    useState({

      material_code: "",
      material_name: "",
      unit: "kg",
      minimum_stock: "",
      status: "active"

    });

  useEffect(() => {

    loadMaterials();

  }, []);

  const loadMaterials =
    async () => {

      try {

        const res =
          await getMaterials();

        setMaterials(
          res.data.data || []
        );

      }
      catch (error) {

        console.log(error);

      }

    };

  const resetForm = () => {

    setEditingId(null);

    setForm({

      material_code: "",
      material_name: "",
      unit: "kg",
      minimum_stock: "",
      status: "active"

    });

  };

  const saveMaterial =
    async (e) => {

      e.preventDefault();

      try {

        if (editingId) {

          await updateMaterial(
            editingId,
            form
          );

        }
        else {

          await createMaterial(
            form
          );

        }

        setShowModal(false);

        resetForm();

        loadMaterials();

      }
      catch (error) {

        console.log(error);

      }

    };

  const editMaterial =
    (item) => {

      setEditingId(item.id);

      setForm(item);

      setShowModal(true);

    };

  const removeMaterial =
    async (id) => {

      if (
        !window.confirm(
          "Delete Material?"
        )
      ) return;

      await deleteMaterial(id);

      loadMaterials();

    };

  return (

    <MainLayout>

      <div className="card shadow-sm border-0">

        <div className="card-header bg-white d-flex justify-content-between align-items-center">

          <h5 className="mb-0">
            Material Master
          </h5>

          <button
            className="btn btn-primary"
            onClick={() =>
              setShowModal(true)
            }
          >

            <FaPlus />
            {" "}
            Add Material

          </button>

        </div>

        <div className="card-body">

          <table className="table table-hover">

            <thead>

              <tr>

                <th>Code</th>
                <th>Name</th>
                <th>Unit</th>
                <th>Min Stock</th>
                <th>Status</th>
                <th width="120">
                  Action
                </th>

              </tr>

            </thead>

            <tbody>

              {
                materials.map(
                  (item) => (

                    <tr
                      key={item.id}
                    >

                      <td>
                        {item.material_code}
                      </td>

                      <td>
                        {item.material_name}
                      </td>

                      <td>
                        {item.unit}
                      </td>

                      <td>
                        {item.minimum_stock}
                      </td>

                      <td>

                        <span
                          className={
                            item.status === "active"
                              ? "badge bg-success"
                              : "badge bg-danger"
                          }
                        >

                          {item.status}

                        </span>

                      </td>

                      <td>

                        <button
                          className="btn btn-sm btn-warning me-2"
                          onClick={() =>
                            editMaterial(item)
                          }
                        >

                          <FaEdit />

                        </button>

                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() =>
                            removeMaterial(
                              item.id
                            )
                          }
                        >

                          <FaTrash />

                        </button>

                      </td>

                    </tr>

                  )
                )
              }

            </tbody>

          </table>

        </div>

      </div>

      {/* Modal */}

      {
        showModal && (

          <div
            className="modal d-block"
            style={{
              background:
                "rgba(0,0,0,.4)"
            }}
          >

            <div className="modal-dialog">

              <div className="modal-content">

                <form
                  onSubmit={
                    saveMaterial
                  }
                >

                  <div className="modal-header">

                    <h5>

                      {
                        editingId
                          ? "Edit Material"
                          : "Add Material"
                      }

                    </h5>

                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => {

                        setShowModal(false);

                        resetForm();

                      }}
                    />

                  </div>

                  <div className="modal-body">

                    <input
                      className="form-control mb-3"
                      placeholder="Material Code"
                      value={
                        form.material_code
                      }
                      onChange={(e) =>
                        setForm({
                          ...form,
                          material_code:
                            e.target.value
                        })
                      }
                    />

                    <input
                      className="form-control mb-3"
                      placeholder="Material Name"
                      value={
                        form.material_name
                      }
                      onChange={(e) =>
                        setForm({
                          ...form,
                          material_name:
                            e.target.value
                        })
                      }
                    />

                    <select
                      className="form-select mb-3"
                      value={form.unit}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          unit:
                            e.target.value
                        })
                      }
                    >

                      <option value="kg">
                        KG
                      </option>

                      <option value="pcs">
                        PCS
                      </option>

                      <option value="roll">
                        ROLL
                      </option>

                    </select>

                    <input
                      type="number"
                      className="form-control mb-3"
                      placeholder="Minimum Stock"
                      value={
                        form.minimum_stock
                      }
                      onChange={(e) =>
                        setForm({
                          ...form,
                          minimum_stock:
                            e.target.value
                        })
                      }
                    />

                  </div>

                  <div className="modal-footer">

                    <button
                      className="btn btn-primary"
                    >

                      Save

                    </button>

                  </div>

                </form>

              </div>

            </div>

          </div>

        )
      }

    </MainLayout>

  );

};

export default Materials;